import { render, staticRenderFns } from "./BrandProfileGrid.vue?vue&type=template&id=5d566ccd&scoped=true"
import script from "./BrandProfileGrid.vue?vue&type=script&lang=js"
export * from "./BrandProfileGrid.vue?vue&type=script&lang=js"
import style0 from "./BrandProfileGrid.vue?vue&type=style&index=0&id=5d566ccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d566ccd",
  null
  
)

export default component.exports